module.exports = __webpack_public_path__ + "static/media/security.dbc4545c.png";